import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onGetEmployerTypes,
  onGetIndustries,
  onGetJobLevels,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'

import { onCreateWorkExperience, onDeleteWorkExperience, onGetPagedAllWorkExperiences, onGetWorkExperience, onUpdateWorkExperience } from '../../../app/modules/areas/graduates/work-experience/core/_requests'
interface WorkExperienceState {
  allWorkExperiences: any
  workExperience: any
  workExperienceTypes: any
  industries: any
  jobLevels: any
  isLoading: boolean
}
const initialState = {
  allWorkExperiences: [],
  workExperience: null,
  workExperienceTypes: [],
  industries: [],
  jobLevels: [],
  isLoading: true,
} as WorkExperienceState

export const fetchWorkExperienceTypes = createAsyncThunk(
  'workExperience/fetchWorkExperienceTypes',
  async () => {
    const data: any = await onGetEmployerTypes()
    return data.data.result.items
  }
)

export const fetchIndustries = createAsyncThunk(
  'workExperience/fetchIndustries',
  async () => {
    const data: any = await onGetIndustries()
    return data.data.result.items
  }
)

export const fetchJobLevels = createAsyncThunk(
  'workExperience/fetchJobLevels',
  async () => {
    const data: any = await onGetJobLevels()
    return data.data.result.items
  }
)


export const fetchAllWorkExperiences = createAsyncThunk(
  'workExperience/fetchAllWorkExperiences',
  async (param: any) => {
    const data: any = await onGetPagedAllWorkExperiences(param)
    return data.data.result
  }
)

export const fetchWorkExperience = createAsyncThunk(
  'workExperience/fetchWorkExperience',
  async (param: any) => {
    const data: any = await onGetWorkExperience(param)
    return data.data.result
  }
)

export const updateWorkExperience = createAsyncThunk(
  'workExperience/updateWorkExperience',
  async (param: any) => {
    const data: any = await onUpdateWorkExperience(param)
    return data.data
  }
)

export const createWorkExperience = createAsyncThunk(
  'workExperience/createWorkExperience',
  async (param: any) => {
    const data: any = await onCreateWorkExperience(param)
    return data.data
  }
)

export const deleteWorkExperience = createAsyncThunk(
  'workExperience/deleteWorkExperience',
  async (param: any) => {
    const data: any = await onDeleteWorkExperience(param)
    return data.data
  }
)

const workExperienceSlice = createSlice({
  name: 'workExperience',
  initialState,
  reducers: {
    clearAllWorkExperiences: (state) => {
      state.allWorkExperiences = []
    },
    clearWorkExperience: (state) => {
      state.workExperience = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllWorkExperiences.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllWorkExperiences.fulfilled, (state: any, action) => {
      state.allWorkExperiences = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllWorkExperiences.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchWorkExperience.fulfilled, (state: any, action) => {
      state.workExperience = action.payload
    })
    builder.addCase(fetchWorkExperienceTypes.fulfilled, (state: any, action) => {
      state.workExperienceTypes = action.payload
    })
    builder.addCase(fetchIndustries.fulfilled, (state: any, action) => {
      state.industries = action.payload
    })
    builder.addCase(fetchJobLevels.fulfilled, (state: any, action) => {
      state.jobLevels = action.payload
    })
  },
})

export const {clearAllWorkExperiences, clearWorkExperience, activateLoading} = workExperienceSlice.actions

export default workExperienceSlice.reducer
